module.exports = __webpack_public_path__ + "static/media/product-drone-photo.00946ab8.svg";